  const config = {
    apiBaseUrl: "https://api.juristbot.ai"
  };

  // const config = {
  //   apiBaseUrl: "https://api.juristbot.in"
  // };

  // const config = {
  //   apiBaseUrl: "http://localhost:3001"
  // };
  
  export default config;
